import React, { useState } from "react";
import { PDFObject } from "react-pdfobject";
import RemoteViewer from "../remote-viewer/remote-viewer";


const AutoViewer = ({ uri = "" }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const ext = (uri?.match(/\.(\w{3,4})($|\?)/) || {})[1] || "";

  if (ext.match(/^(png|jpe?g|webp|gif|tif|tiff?)$/i))
    return (
      <div style={{ textAlign: "center", height: "100%" }}>
        <img style={{ maxWidth: "100%", maxHeight: "100%" }} src={uri}></img>
      </div>
    );

  if (ext.match(/^(pdf)$/i)) return <PDFObject url={uri} height="100%" />;
  if (ext.match(/^(json|txt|csv|xml)$/i)) return <RemoteViewer uri={uri} />;

  // return <p>Unable to preview content</p>
  return <RemoteViewer uri={uri} />;
};

export default AutoViewer;
